import dayjs from '@/js/libs/dayjs/index.ts';
import { isEqualDateRange } from './helpers.js';
// range preset specific
const todayDate = dayjs(new Date()).startOf('day').utc();
const lastWeek = [
    dayjs(todayDate).startOf('week').subtract(6, 'days').toDate(),
    dayjs(todayDate).endOf('week').subtract(7, 'days').endOf('day').toDate(),
];
const last30Days = [dayjs(todayDate).subtract(30, 'day').toDate(), dayjs(todayDate).endOf('day').toDate()];
const lastMonth = [
    dayjs(todayDate).subtract(1, 'month').startOf('month').toDate(),
    dayjs(todayDate).subtract(1, 'month').endOf('month').endOf('day').toDate(),
];
export const rangePresets = [
    {
        title: 'Last week',
        dateRange: lastWeek,
        isActive(selected) {
            return !!selected && isEqualDateRange(selected, lastWeek);
        },
    },
    {
        title: 'Last 30 days',
        dateRange: last30Days,
        default: true,
        isActive(selected) {
            return !!selected && isEqualDateRange(selected, last30Days);
        },
    },
    {
        title: 'Last month',
        dateRange: lastMonth,
        isActive(selected) {
            return !!selected && isEqualDateRange(selected, lastMonth);
        },
    },
];
